export const qualificationsData = {
    education: [
        {
            id: 1,
            title: "Bachelor's Degree in Computer Engineering",
            subtitle: "Dian Nuswantoro University Semarang",
            calendar: "2020"
        },
        // {
        //     id: 2,
        //     title: "Master's Degree in Computer Engineering",
        //     subtitle: "Alexandria University",
        //     calendar: "2026"
        // },
    ],
    experience: [
        {
            id: 1,
            title: "Internship",
            subtitle: "Intsys Lab Research",
            calendar: "2024"
        },
        {
            id: 2,
            title: "Bootcamp iOS Developer",
            subtitle: "Dicoding.com",
            calendar: "2023"
        },
        {
            id: 3,
            title: "Bootcamp Back-End Developer JavaScript",
            subtitle: "Dicoding.com",
            calendar: "2021"
        },
        {
            id: 4,
            title: "Bootcamp Android Developer",
            subtitle: "Dicoding.com",
            calendar: "2020"
        }
    ]
};
